import { useEffect } from "react";
import { generateFakeTelemetry } from "../simulation_interface/FakeDroneSimulation";

export default function useTelemetrySimulation(authenticated, setDrones, defaultLat, defaultLon, simulationEnabled, realTelemetryReceived) {
  useEffect(() => {
    if (!authenticated || !simulationEnabled || realTelemetryReceived) return;

    const interval = setInterval(() => {
      setDrones(prev =>
        prev.map(d => ({
          ...d,
          telemetry: {
            ...generateFakeTelemetry(),
            lat: d.telemetry?.lat ?? defaultLat,
            lon: d.telemetry?.lon ?? defaultLon,
          }
        }))
      );
    }, 200);

    return () => clearInterval(interval);
  }, [authenticated, simulationEnabled, realTelemetryReceived]);
}
